<template>
  <div>
    <main-layout>
      <AdminMenu />
      <v-container>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <h1>{{ $t('self_referral_list') }}</h1>
          </v-flex>
          <v-flex xs12 sm6 justify-end style="display: flex">
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              <span class="px-1">{{ $t('advanced search') }}</span>

              <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>
            <v-btn dark outline color="primary" @click="handleExportXlsx">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>
          <v-flex v-if="showAdvancedSearch" xs12>
            <AdvanceSearch
              :filters="filters"
              @onSearch="handleSearch"
              @onClearSearch="handleClearSearch"
            />
          </v-flex>
        </v-layout>

        <div class="mt-2">
          <DataTable :filters="filters" :is-export="fetchExport" />
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import AdminMenu from '../AdminMenu.vue'
import DataTable from './DataTable.vue'
import AdvanceSearch from './AdvanceSearch.vue'

export default {
  components: {
    DataTable,
    AdvanceSearch,
    AdminMenu
  },
  data() {
    return {
      showAdvancedSearch: false,
      filters: {
        name: '',
        age: '',
        gender: '',
        risk: '',
        status: '',
        phone_no: '',
        date_from: '',
        date_to: ''
      },
      fetchExport: null
    }
  },
  methods: {
    handleSearch(value) {
      if (value && Object.keys(value).length > 0) {
        this.filters = {
          ...value
        }
      }
    },
    handleClearSearch() {
      this.filters = {
        name: '',
        age: '',
        gender: '',
        risk: '',
        status: '',
        phone_no: '',
        date_from: '',
        date_to: ''
      }
    },
    handleExportXlsx() {
      this.fetchExport = new Date()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/index.vue